import React from "react";
import { Button, Card, OverlayTrigger, Tooltip } from "react-bootstrap";
import { findIcon } from "views/dashboard/icons";

const GraphCardsHeader = ({
  title = "",
  tooltip = "",
  titleCenter = false,
  hideUnderline = false,
  showDownloadButtons = false,
  needCSVDownload = false,
  needImageDownload = false,
  downloadCSV = () => {},
  downloadImage = () => {},
  subRightComponent = <></>,
  rightComponent = <></>,
}) => {
  const graphTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {tooltip}
    </Tooltip>
  );

  return (
    <Card.Header>
      <Card.Title
        as="div"
        className={`d-flex ${
          titleCenter ? "justify-content-center " : "justify-content-between "
        } align-items-center`}
      >
        <div className="d-flex justify-content-center align-items-center gap-2">
          <h5
            className={`${
              hideUnderline ? "" : titleCenter ? "subHeading" : "subHeadingLeft"
            }  position-relative mb-0`}
            style={{ fontSize: "16px" }}
          >
            {title}
          </h5>
          {!!tooltip && (
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 50, hide: 200 }}
              overlay={graphTooltip}
            >
              <span className="text-primary cursor-pointer">
                {findIcon("info", "outline", 20)}
              </span>
            </OverlayTrigger>
          )}
        </div>

        <div className="d-flex gap-2">
          {subRightComponent}

          {showDownloadButtons && needImageDownload && (
            <Button
              variant="soft-primary"
              className="d-flex gap-2 align-items-center rounded-2 text-nowrap"
              onClick={downloadImage}
              size="sm"
            >
              {findIcon("Document Arrow Down", "dual-tone", "20")}
              <span className="d-none d-md-inline-block">Download Graph</span>
            </Button>
          )}

          {showDownloadButtons && needCSVDownload && (
            <Button
              variant="soft-success"
              className="d-flex gap-2 align-items-center rounded-2 text-nowrap"
              onClick={downloadCSV}
              size="sm"
            >
              {findIcon("export", "dual-tone", "20")}
              <span className="d-none d-md-inline-block">Export</span>
            </Button>
          )}
        </div>

        {rightComponent}
      </Card.Title>
    </Card.Header>
  );
};

export default GraphCardsHeader;
